// extracted by mini-css-extract-plugin
export default {"wishListsErrorContainer":"ErrorFallback_wishListsErrorContainer__aqcAg"};